import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { IndividualDashboardComponent } from './individual-dashboard/individual-dashboard.component';
import { UserComponent } from './user/user.component';
import { AuthGuard } from './auth.guard';
import { SiteManagerComponent } from './site-manager/site-manager.component';
import { DemandTrendAnalysisComponent } from './demand-trend-analysis/demand-trend-analysis.component';
import { DemandTrendAnalysisAvailabilityComponent } from './demand-trend-analysis-availability/demand-trend-analysis-availability.component';
import { TransfomerManagerComponent } from './transformer/transformer-manager/transfomer-manager.component';
import { DeviceManagerComponent } from './device/device-master/devicemaster.component';
import { ReportComponent } from './reports/report.component';
import { AlertReportComponent } from './reports/alert/alert-report.component';
import { AccessAuthGuard } from './access-auth.guard';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { OnlineofflinereportComponent } from './reports/onlineofflinereport/onlineofflinereport.component';
import { OnlineofflineanalysisComponent } from './demand-trend-analysis/onlineofflineanalysis/onlineofflineanalysis.component';
import { HvlvdiffreportComponent } from './reports/hvlvdiffreport/hvlvdiffreport.component';
import { EmsComponent } from './ems/ems.component';
import { EnergymeterManagerComponent } from './energymeter-manager/energymeter-manager.component';
import { EmsreportComponent } from './reports/emsreport/emsreport.component';
import { DashboardSelectionComponent } from './dashboard-selection/dashboard-selection.component';
import { SimreportComponent } from './reports/simreport/simreport.component';
import { EmsIndividualDashboardComponent } from './ems-individual-dashboard/ems-individual-dashboard.component';
import { EmstreeComponent } from './emstree/emstree.component';
import { EmsalertreportComponent } from './emsalertreport/emsalertreport.component';
import { MqttdashboardComponent } from './mqttdashboard/mqttdashboard.component';
import { DetectionReportComponent } from './reports/detection-report/detection-report.component';
import { PumpdashboardComponent } from './pumpdashboard/pumpdashboard.component';
import { PumpmanagerComponent } from './pumpmanager/pumpmanager.component';
import { PumpgatewayreportComponent } from './reports/pumpgatewayreport/pumpgatewayreport.component';
import { PumpalertreportComponent } from './reports/pumpalertreport/pumpalertreport.component';
import { PumpindividualComponent } from './pumpindividual/pumpindividual.component';
import { TransformeranalyticsComponent } from './transformeranalytics/transformeranalytics.component';
import { FeederdashboardComponent } from './feeder/feederdashboard/feederdashboard.component';
import { FeedermanagerComponent } from './feeder/feedermanager/feedermanager.component';
import { TransformermaintainanceComponent } from './transformermaintainance/transformermaintainance.component';
import { MaintainanceplanningComponent } from './transformermaintainance/maintainanceplanning/maintainanceplanning.component';
import { JourgemachinedashboardComponent } from './jourgemachinedashboard/jourgemachinedashboard.component';
import { MaintainanceComponent } from './transformermaintainance/maintainance/maintainance.component';
import { DigitaltwinComponent } from './individual-dashboard/digitaltwin/digitaltwin.component';
import { SolardashboardComponent } from './solarDashboard/solardashboard/solardashboard.component';
import { SolarManagerComponent } from './solarDashboard/solar-manager/solar-manager.component';
import { AnnunciatorComponent } from './annunciator/annunciator.component';
import { RealTimeGraphsComponent } from './individual-dashboard/real-time-graphs/real-time-graphs.component';
import { LiveTableComponent } from './individual-dashboard/live-table/live-table.component';
import { AmcSettingComponent } from './amc-setting/amc-setting.component';
import { DigiMonitoringComponent } from './digi-monitoring/digi-monitoring.component';
import { DigiManagerComponent } from './digi-manager/digi-manager.component';
import { TransformerEfficiencyCalComponent } from './transformer-efficiency-cal/transformer-efficiency-cal.component';
import { PenaltyComponent } from './penalty/penalty.component';
import { DeviceDiagosticComponent } from './device-diagostic/device-diagostic.component';
import { MotorDashboardComponent } from './motor-dashboard/motor-dashboard.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/signin',
    pathMatch: 'full'
  },
  {
    path: 'auth/signin',
    component: LoginComponent
  },
  {
    path: '', component: SideNavComponent, canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [AccessAuthGuard]},
      { path: 'individual-status', component: IndividualDashboardComponent, canActivate: [AccessAuthGuard] },
      { path: 'user', component: UserComponent, canActivate: [AccessAuthGuard]},
      { path: 'site', component: SiteManagerComponent, canActivate: [AccessAuthGuard]},
      { path: 'demand-trend', component: DemandTrendAnalysisComponent, canActivate: [AccessAuthGuard] },
      { path: 'downtime-analysis', component: DemandTrendAnalysisAvailabilityComponent, canActivate: [AccessAuthGuard] }, 
      { path: 'updowntime-analysis', component: OnlineofflineanalysisComponent, canActivate: [AccessAuthGuard] },   
      {path: 'transformerManager', component: TransfomerManagerComponent, canActivate: [AccessAuthGuard]},   
      {path: 'deviceMaster', component: DeviceManagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'amc', component: AmcSettingComponent, canActivate: [AccessAuthGuard]},
      {path: 'report', component: ReportComponent, canActivate: [AccessAuthGuard]},
      {path: 'report/:transformerid', component: ReportComponent, canActivate: [AccessAuthGuard]},
      {path: 'alertReport', component:AlertReportComponent, canActivate: [AccessAuthGuard]},
      {path: 'upDownReport', component:OnlineofflinereportComponent, canActivate: [AccessAuthGuard]},
      {path: 'hvlvdiff', component:HvlvdiffreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'ems', component:EmsComponent, canActivate: [AccessAuthGuard]},
      {path: 'emstree', component:EmstreeComponent, canActivate: [AccessAuthGuard]},
      {path: 'emsalertreport', component:EmsalertreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'emsindividual', component:EmsIndividualDashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'energymetermanager', component:EnergymeterManagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'emsreport', component:EmsreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'simreport', component:SimreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'mqttDashboard', component:MqttdashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'detectionReport', component:DetectionReportComponent, canActivate: [AccessAuthGuard]},
      {path: 'pumpDashboard', component:PumpdashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'pumpManager', component:PumpmanagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'pumpgatewayreport', component:PumpgatewayreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'pumpalertreport', component:PumpalertreportComponent, canActivate: [AccessAuthGuard]},
      {path: 'pumpindividual', component:PumpindividualComponent, canActivate: [AccessAuthGuard]},
      {path: 'trafoanalytics', component:TransformeranalyticsComponent, canActivate: [AccessAuthGuard]},
      {path: 'feederDashboard', component:FeederdashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'feederManager', component:FeedermanagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'maintainance', component:MaintainanceplanningComponent, canActivate: [AccessAuthGuard]},
      {path: 'addmaintainance', component:MaintainanceComponent, canActivate: [AccessAuthGuard]},
      {path: 'jourgeMachineDahboard', component:JourgemachinedashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'digitalTwin', component:DigitaltwinComponent, canActivate: [AccessAuthGuard]},
      {path: 'solarDashboard', component:SolardashboardComponent, canActivate: [AccessAuthGuard]},
      {path: 'solarManager', component:SolarManagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'announceator', component:AnnunciatorComponent, canActivate: [AccessAuthGuard]},
      {path: 'realTime', component:RealTimeGraphsComponent, canActivate: [AccessAuthGuard]},
      {path: 'realTimeTable', component:LiveTableComponent, canActivate: [AccessAuthGuard]},
      {path: 'digiDashboard', component:DigiMonitoringComponent, canActivate: [AccessAuthGuard]},
      {path: 'digiManager', component:DigiManagerComponent, canActivate: [AccessAuthGuard]},
      {path: 'analytics', component:TransformerEfficiencyCalComponent, canActivate: [AccessAuthGuard]},
      {path: 'penaltyReport', component:PenaltyComponent, canActivate: [AccessAuthGuard]},
      {path: 'device_diagostic', component:DeviceDiagosticComponent, canActivate: [AccessAuthGuard]},
         {path: 'access-denied', component:AccessDeniedComponent, canActivate: [AccessAuthGuard]},
         {path: 'motor', component:MotorDashboardComponent, canActivate: [AccessAuthGuard]},
 
   
    ]
  },
  {
  path: 'dashboardselection', component:DashboardSelectionComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
